module.exports = __webpack_public_path__ + "img/send-icon.b70b3629.svg";